import { makeObservable, observable } from 'mobx';
import { NavigateFunction } from 'react-router-dom';

import { Space, Step } from './entities';

export class Context {
  space: Space;

  user: any;

  step: Step;

  // To be used in the Modals
  navigate: NavigateFunction;

  get member() {
    return this.space.members.find((member) => member.email === this.user.email);
  }

  constructor() {
    makeObservable(this, {
      space: observable,
      user: observable,
      step: observable,
    });
  }
}

export const context = new Context();
